import React from "react";
import { useNavigate } from "react-router-dom";
import Datatable from "./common/datatable";
import { useViewIndustryQuery } from "../hooks/industry/industryList";
import { useViewCategory } from "../hooks/categorys/category.showall";
import { useViewClientQuery } from "../hooks/clients/viewClientList";
import ActionMenu from "./common/menu";
import FallbackImage from "./common/fallbackImage";

const CaseStudyData = ({ data, onEdit, onView, onDelete }) => {
  const navigate = useNavigate();

  const handleView = (client) => {
    const id = client._id || client.id;
    navigate(`/case-studies/view/${id}`);
  };

  const { data: industriesData } = useViewIndustryQuery();
  const { data: categoriesData } = useViewCategory();
  const { data: clientData } = useViewClientQuery();

  const industriesList = Array.isArray(industriesData?.data)
    ? industriesData.data
    : Array.isArray(industriesData)
      ? industriesData
      : [];
  const categoriesList = Array.isArray(categoriesData?.data)
    ? categoriesData.data
    : Array.isArray(categoriesData?.categories)
      ? categoriesData.categories
      : Array.isArray(categoriesData)
        ? categoriesData
        : [];
  const clientList = Array.isArray(clientData?.data)
    ? clientData.data
    : Array.isArray(clientData?.clients)
      ? clientData.clients
      : Array.isArray(clientData)
        ? clientData
        : [];

  const getIndustryTitle = (val) => {
    if (!val || (Array.isArray(val) && val.length === 0)) return "-";

    if (Array.isArray(val)) {
      return val
        .map((item) => {
          if (typeof item === "string") {
            const found = industriesList.find(
              (i) => i._id === item || i.id === item,
            );
            return found ? found.title : item;
          }
          if (item && item.title) return item.title;
          if (item && item._id) {
            const found = industriesList.find(
              (i) => i._id === item._id || i.id === item._id,
            );
            return found ? found.title : item._id;
          }
          return "-";
        })
        .join(", ");
    }

    if (typeof val === "string") {
      const found = industriesList.find((i) => i._id === val || i.id === val);
      return found ? found.title : val;
    }

    if (typeof val === "object") {
      if (val.title) return val.title;
      if (val._id) {
        const found = industriesList.find(
          (i) => i._id === val._id || i.id === val._id,
        );
        return found ? found.title : val._id;
      }
    }

    return "-";
  };

  const getCategoryTitle = (val) => {
    if (!val || (Array.isArray(val) && val.length === 0)) return "-";

    if (Array.isArray(val)) {
      return val
        .map((item) => {
          if (typeof item === "string") {
            const found = categoriesList.find(
              (c) => c._id === item || c.id === item,
            );
            return found ? found.title : item;
          }
          if (item && item.title) return item.title;
          if (item && item._id) {
            const found = categoriesList.find(
              (c) => c._id === item._id || c.id === item._id,
            );
            return found ? found.title : item._id;
          }
          return "-";
        })
        .join(", ");
    }

    if (typeof val === "string") {
      const found = categoriesList.find((c) => c._id === val || c.id === val);
      return found ? found.title : val;
    }

    if (typeof val === "object") {
      if (val.title) return val.title;
      if (val._id) {
        const found = categoriesList.find(
          (c) => c._id === val._id || c.id === val._id,
        );
        return found ? found.title : val._id;
      }
    }

    return "-";
  };

  const getClientName = (val) => {
    if (!val || (Array.isArray(val) && val.length === 0)) return "-";

    if (Array.isArray(val)) {
      return val
        .map((item) => {
          if (typeof item === "string") {
            const found = clientList.find(
              (c) => c._id === item || c.id === item,
            );
            return found ? found.name : item;
          }
          if (item && item.name) return item.name;
          if (item && item._id) {
            const found = clientList.find(
              (c) => c._id === item._id || c.id === item._id,
            );
            return found ? found.name : item._id;
          }
          return "-";
        })
        .join(", ");
    }

    if (typeof val === "string") {
      const found = clientList.find((c) => c._id === val || c.id === val);
      return found ? found.name : val;
    }

    if (typeof val === "object") {
      if (val.name) return val.name;
      if (val._id) {
        const found = clientList.find(
          (c) => c._id === val._id || c.id === val._id,
        );
        return found ? found.name : val._id;
      }
    }

    return "-";
  };

  const columns = [
    {
      key: "images",
      label: "Images",
      className: "company-logo",
      render: (value) => {
        // Only show the first image from the collection
        const firstImage = Array.isArray(value) ? value[0] : value;

        return firstImage ? (
          <FallbackImage
            src={firstImage}
            alt="Case Study"
            style={{
              width: 50,
              height: 50,
              borderRadius: "6px",
              objectFit: "cover",
            }}
          />
        ) : (
          "-"
        );
      },
    },
    { key: "title", label: "Title" },
    {
      key: "description",
      label: "Description",
      render: (value) => <span className="tab-tds">{value}</span>,
    },
    {
      key: "industry",
      label: "Industry Title",
      render: (value) => getIndustryTitle(value),
    },
    {
      key: "category",
      label: "Category Title",
      render: (value) => getCategoryTitle(value),
    },
    {
      key: "client",
      label: "client Name",
      render: (value) => getClientName(value),
    },
    {
      key: "actions",
      label: "Actions",
      render: (value, row) => (
        <ActionMenu
          row={row}
          onView={handleView}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ),
    },
  ];
  return (
    <>
      <Datatable data={data} columns={columns} />
    </>
  );
};

export default CaseStudyData;
